module.exports = __webpack_public_path__ + "img/chevron_back.90ca8312.svg";